export default "data:image/gif;base64,R0lGODlhFQAEAPABAKGhoQAAACH5BAUKAAEALAAAAAAVAAQAAAINjB+gC+jP2ptn0WskLQA7"